import { useCallback } from 'react';
import { useAuth0 } from '@auth0/auth0-react';

export function useApi() {
  const { getAccessTokenSilently, isAuthenticated } = useAuth0();

  const authFetch = useCallback(async (path: string, options?: RequestInit) => {
    if (options?.signal?.aborted) throw new DOMException('Aborted', 'AbortError');
    const token = await getAccessTokenSilently({
      authorizationParams: { audience: process.env.REACT_APP_AUTH0_AUDIENCE }
    });
    if (options?.signal?.aborted) throw new DOMException('Aborted', 'AbortError');
    return fetch(`${process.env.REACT_APP_API_URL ?? ''}${path}`, {
      ...options,
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}`, ...options?.headers }
    });
  }, [getAccessTokenSilently]);

  const anonFetch = (path: string) => fetch(path);

  return { authFetch, anonFetch, isAuthenticated };
}
